import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { CSVLink } from "react-csv";
import { format } from "date-fns";
import Swal from "sweetalert2";
import CSVReader from "react-csv-reader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactExport from "react-data-export";
import _ from "lodash";

// COMPONENTS
import LoadingMutation from "../Loading/LoadingMutation";

// HOOKS
import useTransferLoan from "../../hooks/useTransferLoan";
import useTransferCount from "../../hooks/useTransferCount";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import TransferLoanTable from "./TransferLoanTable";
import DataEmpty from "../DataEmpty";
import PrevPage from "../../components/Pagination/PrevPage";
import NumberPage from "../../components/Pagination/NumberPage";
import NextPage from "../../components/Pagination/NextPage";
import SelectRows from "../../components/Pagination/SelectRows";

// OTHER
import numeral from "numeral";

// AWS
import { API, Auth, Storage } from "aws-amplify";

// UTILS
import { getCurrentLocalDateTime, pad } from "../../utils/getLocalDateTime";
// Lotte
import Lottie from "react-lottie";
import Loading from "../../animation/loading.json";
import LoadingButton from "components/Loading/LoadingButton";
import { SubmitLocalStorageSearch } from "function";
import Skeleton from "react-loading-skeleton";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const optionsPackage = [
  {
    label: "All Package",
    value: "All",
  },
  {
    label: "อุปโภค / บริโภค",
    value: "อุปโภค / บริโภค",
  },
  {
    label: "ท่องเที่ยว",
    value: "ท่องเที่ยว",
  },
  {
    label: "ธุรกิจ",
    value: "ธุรกิจ",
  },
];

const optionsStatus = [
  {
    label: "ยืนยัน",
    value: "ยืนยัน",
  },
  {
    label: "สมบูรณ์",
    value: "สมบูรณ์",
  },
];

const optionsLimit = [
  {
    label: 50,
    value: 50,
  },
  { label: 100, value: 100 },
  { label: 150, value: 150 },
  { label: 200, value: 200 },
  { label: 250, value: 250 },
  { label: 300, value: 300 },
  { label: 350, value: 350 },
  { label: 400, value: 400 },
  { label: 450, value: 450 },
  { label: 500, value: 500 },
  { label: 1000, value: 1000 },
];
function TransferLoanMain() {
  const Limit = 50;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.initializeApp);
  const searchBar = useSelector((state) => state.searchBar);

  const DEFAULT_QUERY = {
    Limit,
    countData: 1,
    request_id: "",
    package: optionsPackage[0].value,
    status: optionsStatus[0].value,
    min: "",
    max: "",
    SELECT_ALL: true,
  };

  const [currentType, setCurrentType] = useState("ยืนยัน");
  const [countObj, setCountObj] = useState({
    ยืนยัน: 0,
    สมบูรณ์: 0,
  });

  const { datas, loading, error, getData, count, setDatas, setLoading } =
    useTransferLoan(DEFAULT_QUERY);

  const {
    datas: datasCount,
    loading: loadingCount,
    error: errorCount,
    getData: getDataCount,
  } = useTransferCount(DEFAULT_QUERY);

  const [searchBy, setSearchBy] = useState("phone_number");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState({ value: Limit, label: Limit });
  const [pageType, setPageType] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingExportInterface, setLoadingExportInterface] = useState(false);
  const [loadingImport, setLoadingImport] = useState(false);
  const [dataExport, setDataExport] = useState([]);
  const [type, setType] = useState("exportExcel");
  const [query, setQuery] = useState(DEFAULT_QUERY);
  const [interfaceCreate, setInterfaceCreate] = useState([]);

  const onSearchBy = (value) => {
    setSearchBy(value);
  };

  const onClickResetFilter = async () => {
    setQuery(DEFAULT_QUERY);
    dispatch(onChangeSearchBar(""));
    setSearchBy("phone_number");
    setPageIndex(0);
    setPageType(null);
    await getData(DEFAULT_QUERY);
    await getDataCount(DEFAULT_QUERY);
  };

  const onChangeLimit = async (e) => {
    setPageSize(e);
    setPageIndex(0);
    let newQuery = {
      ...query,
      Limit: e.value,
    };
    delete newQuery?.ExclusiveStartKey;
    setQuery(newQuery);
    await getData(newQuery);
  };

  const onSelect = (name) => (e) => {
    const { value } = e;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onField = (e) => {
    const { name, value } = e.target;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getExclusiveStartKey = (index) => {
    if (query.name) {
      return `request_id=${datas[index].request_id}&verify=true&name=${datas[index].name}`;
    } else if (query.requestamount) {
      return `request_id=${datas[index].request_id}&verify=true&requestamount=${datas[index].requestamount}`;
    } else if (query.phone_number) {
      return `request_id=${datas[index].request_id}&verify=true&phone_number=${datas[index].phone_number}`;
    }
    return `request_id=${datas[index].request_id}&loan_status=${datas[index].loan_status}&executeTime=${datas[index].executeTime}`;
  };

  const onClickPrevPage = async () => {
    let newQuery = {
      ...query,
      Limit: +pageSize.value,
      countData: 1,
      ScanIndexForward: true,
    };
    if (pageType === "NEXT" && !datas.length) {
      newQuery = {
        ...newQuery,
      };
    } else {
      newQuery = {
        ...newQuery,
        ExclusiveStartKey: getExclusiveStartKey(0),
      };
    }
    console.log("pageSize", pageSize);
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
    await getData(newQuery, { sortBy: true });
  };

  const onClickNextPage = async () => {
    const lastIndex = datas.length - 1;
    const newQuery = {
      ...query,
      countData: 1,
      ScanIndexForward: false,
      Limit: +pageSize.value,
      ExclusiveStartKey: getExclusiveStartKey(lastIndex),
    };
    setPageIndex((prev) => prev + 1);
    setPageType("NEXT");
    await getData(newQuery);
  };

  const onClickExportExcelInterface = async () => {
    try {
      setLoadingExportInterface(true);
      const click = document.getElementById("interfaceCreate");
      const data = await API.get(
        "MoneyHubAdmin",
        "/transferLoan/interfaceCreate",
        {
          queryStringParameters: {
            TableName: "loan_request",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const parseData = JSON.parse(data.body);
      setInterfaceCreate(parseData?.Items);
      click.click();
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingExportInterface(false);
    }
  };

  const onSubmitFilter = async () => {
    SubmitLocalStorageSearch(searchBar);
    setPageIndex(0);
    setPageType(null);
    let newQuery = {
      ...query,
    };
    if (searchBar.value) {
      newQuery = {
        ...query,
        [searchBy]: searchBar.value,
      };
    } else {
      delete newQuery?.request_id;
      delete newQuery?.name;
      delete newQuery?.adminName;
      delete newQuery?.requestamount;
      delete newQuery?.phone_number;
    }
    delete newQuery?.ExclusiveStartKey;
    setQuery(newQuery);
    await getData(newQuery);
    await getDataCount(newQuery);
  };

  if (loading)
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  if (error) return <p className="text-black">Error</p>;

  const totalPage = Math.ceil(count / pageSize.value);
  const sliceNumber = 1;

  const paginationPages = new Array(1)?.fill(0)?.slice(0, sliceNumber);
  const canNextPage = pageIndex + 1 !== totalPage;
  const canPreviousPage = pageIndex !== 0;

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  const onImportExcel = async (importDatas, fileInfo) => {
    setLoadingImport(true);

    for (const importData of importDatas) {
      let payloadTarget = {
        fullname: null,
        adminName: null,
        job_no: null,
        tx: null,
        transferDate: "",
      };

      const regexDate = /^\d{4}-\d{2}-\d{2}$/;

      if (
        !regexDate.test(importData?.transferDate) ||
        getCurrentLocalDateTime(new Date(!importData?.transferDate)).fullDate >
          getCurrentLocalDateTime().fullDate
      ) {
        importData.transferDate = new Date();
      }

      const payloadSource = {
        fullname: importData.name,
        job_no: importData.job_no,
        adminName: user.username,
        tx: _.upperCase(importData.tx),
        transferDate: importData?.transferDate,
      };

      Object.assign(payloadTarget, payloadSource);

      await API.put("MoneyHubAdmin", "/loanRequest/tx", {
        body: { ...payloadTarget },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
    }

    try {
      await API.post("MoneyHubAdmin", `/fileExcel/historySync`, {
        body: {
          username: user.username,
          function_name: "TRANSFER_LOAN",
          fileName: fileInfo.name,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
    } catch (error) {
      console.log("first error", error);
    }
    await getData(query, { isLoading: false });
    setLoadingImport(false);
    toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
  };

  const getCountDown = (value) => {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = value - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
    return (
      pad(checkLessZero(days)) +
      ":" +
      pad(checkLessZero(hours)) +
      ":" +
      pad(checkLessZero(minutes)) +
      ":" +
      pad(checkLessZero(seconds))
    );
  };

  const checkLessZero = (number) => {
    return number < 0 ? "00" : number;
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      console.log("data", data[i].original.executeTime);
      result.push([
        {
          value: data[i].original.loan_kbank_id,
          style,
        },
        {
          value: data[i].original.tx,
          style,
        },
        {
          value: data[i].original.name + " " + data[i].original.lastname,
          style,
        },
        {
          value: data[i].original.requestamount,
          style,
        },
        {
          value: data[i].original.amount,
          style,
        },
        {
          value: data[i].original.purpose,
          style,
        },
        {
          value: data[i].original.timestamp
            ? format(new Date(data[i].original.timestamp), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.executeTime
            ? format(new Date(data[i].original.executeTime), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.loan_status,
          style,
        },
        {
          value: getCountDown(
            Date.now() +
              (new Date(data[i].original.dueTime).getTime() - Date.now())
          ),
          style,
        },
        {
          value: data[i].original.adminName || "",
          style,
        },
        {
          value:
            data[i].original.promotion_code + `(${data[i].original.promo})` ||
            "",
          style,
        },
        {
          value:
            `${+data[i].original.interest_rate + data[i].original.promo}%` ||
            "",
          style,
        },
        {
          value: data[i].original.period || "",
          style,
        },
        {
          value: data[i].original.bank || "",
          style,
        },
        {
          value: `${data[i].original.bankNo}` || "",
          style,
        },
        {
          value:
            `${format(
              new Date().setDate(
                new Date(data[i].original.executeTime).getDate() + 2
              ),
              "dd-MM-yyyy"
            )}` || "",
          style,
        },
        {
          value: data[i].original.completedAt
            ? format(new Date(data[i].original.completedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.completedBy || "-",
          style,
        },
        {
          value: data[i].original.approvedAt
            ? format(new Date(data[i].original.approvedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.approvedBy || "-",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleInterface = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: `${data[i]?.REFERENCE}`,
          style,
        },
        {
          value: `${data[i]?.TITLE}`,
          style,
        },
        {
          value: `${data[i]?.NAME}`,
          style,
        },
        {
          value: `${data[i]?.MOBILE_PHONE}`,
          style,
        },
        {
          value: `${data[i]?.TAX_ID}`,
          style,
        },
        {
          value: `${data[i]?.CONTRACT_TYPE}`,
          style,
        },
        {
          value: `${data[i]?.LOAN_AMOUNT}`,
          style,
        },
        {
          value: `${data[i]?.CURRENCY}`,
          style,
        },
        {
          value: `${data[i]?.PAYMENT_DOC_DATE}`,
          style,
        },
        {
          value: `${data[i]?.PAYMENT_POST_DATE}`,
          style,
        },
        {
          value: `${data[i]?.VALUE_DATE}`,
          style,
        },
        {
          value: `${data[i]?.REGISTRATION_TYPE}`,
          style,
        },
        {
          value: `${data[i]?.EMAIL}`,
          style,
        },
        {
          value: `${data[i]?.ADDRESS}`,
          style,
        },
        {
          value: `${data[i]?.REGION}`,
          style,
        },
        {
          value: `${data[i]?.POSTAL_CODE}`,
          style,
        },
        {
          value: `${data[i]?.BANK_KEY}`,
          style,
        },
        {
          value: `${data[i]?.BANK_ACCOUNT}`,
          style,
        },
        {
          value: `${data[i]?.BANK_TYPE}`,
          style,
        },
        {
          value: `${data[i]?.ACCT_HOLDER}`,
          style,
        },
        {
          value: `${data[i]?.CUSTOMER_PAY_TERM}`,
          style,
        },
        {
          value: `${data[i]?.VENDOR_PAY_TERM}`,
          style,
        },
        {
          value: `${data[i]?.BRANCH_CODE}`,
          style,
        },
        {
          value: `${data[i]?.COMPANY_CODE}`,
          style,
        },
      ]);
    }
    return result;
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // border: borderColumn,
  };

  const multiDataSetInterface = [
    {
      columns: [
        {
          title: "REFERENCE",
          width: { wch: 24 },
          style,
        },
        {
          title: "TITLE",
          width: { wch: 16 },
          style,
        },
        {
          title: "NAME",
          width: { wch: 38 },
          style,
        },
        {
          title: "MOBILE_PHONE",
          width: { wch: 18 },
          style,
        },
        {
          title: "TAXI_ID",
          width: { wch: 18 },
          style,
        },
        {
          title: "CONTRACT_TYPE",
          width: { wch: 14 },
          style,
        },
        {
          title: "LOAN_AMOUNT",
          width: { wch: 18 },
          style,
        },
        {
          title: "CURRENCY",
          width: { wch: 14 },
          style,
        },
        {
          title: "PAYMENT_DOC_DATE",
          width: { wch: 26 },
          style,
        },
        {
          title: "PAYMENT_POST_DATE",
          width: { wch: 26 },
          style,
        },
        {
          title: "VALUE_DATE",
          width: { wch: 26 },
          style,
        },
        {
          title: "REGISTRATION_TYPE",
          width: { wch: 14 },
          style,
        },
        {
          title: "EMAIL",
          width: { wch: 44 },
          style,
        },
        {
          title: "ADDRESS",
          width: { wch: 140 },
          style,
        },
        {
          title: "REGION",
          width: { wch: 14 },
          style,
        },
        {
          title: "POSTAL_CODE",
          width: { wch: 18 },
          style,
        },
        {
          title: "BANK_KEY",
          width: { wch: 18 },
          style,
        },
        {
          title: "BANK_ACCOUNT",
          width: { wch: 24 },
          style,
        },
        {
          title: "BANK_TYPE",
          width: { wch: 14 },
          style,
        },
        {
          title: "ACCT_HOLDER",
          width: { wch: 36 },
          style,
        },
        {
          title: "CUSTOMER_PAY_TERM",
          width: { wch: 36 },
          style,
        },
        {
          title: "VENDOR_PAY_TERM",
          width: { wch: 36 },
          style,
        },
        {
          title: "BRANCH_CODE",
          width: { wch: 36 },
          style,
        },
        {
          title: "COMPANY_CODE",
          width: { wch: 36 },
          style,
        },
      ],
      data: createDataWithStyleInterface(interfaceCreate),
    },
  ];

  const multiDataSet = [
    {
      columns: [
        {
          title: "Job no",
          width: { wch: 28 },
          style,
        }, //pixels width
        {
          title: "Tx",
          width: { wch: 38 },
          style,
        }, //
        {
          title: "ชื่อ",
          width: { wch: 38 },
          style,
        }, //pixels width
        {
          title: "วงเงินที่ได้",
          width: { wch: 24 },
          style,
        }, //char width
        {
          title: "วงเงินที่ขอ",
          width: { wch: 24 },
          style,
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่แก้ไข",
          width: { wch: 24 },
          style,
        },
        {
          title: "สถานะ",
          width: { wch: 24 },
          style,
        },
        {
          title: "Time Remain",
          width: { wch: 36 },
          style,
        },
        {
          title: "แก้ไขโดย",
          width: { wch: 24 },
          style,
        },
        {
          title: "Promotion Code",
          width: { wch: 24 },
          style,
        },
        {
          title: "อัตราดอกเบี้ย",
          width: { wch: 24 },
          style,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 24 },
          style,
        },
        {
          title: "ธนาคาร",
          width: { wch: 24 },
          style,
        },
        {
          title: "เลขที่บัญชี",
          width: { wch: 32 },
          style,
        },
        {
          title: "วันที่โอน",
          width: { wch: 24 },
          style,
        },
        {
          title: "Complete Date",
          width: { wch: 24 },
          style,
        },
        {
          title: "Complete By",
          width: { wch: 24 },
          style,
        },
        {
          title: "Approve Date",
          width: { wch: 24 },
          style,
        },
        {
          title: "Approved By",
          width: { wch: 24 },
          style,
        },
      ],
      data: createDataWithStyle(selectedRows),
    },
  ];

  const onClickExport = () => {
    const exportClick = document.getElementById("transferLoan");
    exportClick.click();
  };

  const onComplete = async () => {
    for (const data of datas) {
      let executeTime = getCurrentLocalDateTime();
      await API.put("MoneyHubAdmin", "/loanRequest", {
        body: {
          request_id: data.request_id,
          phone_number: data.phone_number, //WHERE KEY 1
          timestamp: data.timestamp, //WHERE KEY 2
          fileBuro: data.originalFileBuro,
          deviceToken: data.deviceToken,
          reason: data.reason,
          status: "สมบูรณ์",
          referal_one: data.referal_one,
          referal_two: data.referal_two,
          paydate: data.paydate,
          adminName: user.username,
          executeTime: executeTime?.timestamp,
          name: data.name,
          lastname: data.lastname,
          refinance_id: data.refinance_id,
          loan_kbank_id: data.loan_kbank_id,
          tx: "123",
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      await API.post("MoneyHubAdmin", "/loan", {
        body: {
          phone_number: data.phone_number,
          request_id: data.request_id,
          purpose: data.purpose,
          period: data.period,
          requestamount: data.requestamount,
          payPerMonth: data.payPerMonth,
          completedAt: executeTime.date, //MARK
          dueTime: data.paydate,
          fullname: `${data.name} ${data.lastname}`,
          name: data.name,
          lastname: data.lastname,
          adminName: user.username,
          deviceToken: data.deviceToken,
          promo: data.promo,
          citizenid: data.citizenid,
          birthdateTh: data.birthdateTh,
          currentAddress: data.currentAddress,
          bankNo: data.bankNo,
          addressDesc: data.addressDesc,
          loan_kbank_id: data.loan_kbank_id,
          loanRequest: data,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
    }
  };

  return (
    <ContainerContent>
      <div className="mx-4 w-full mb-2 lg:flex items-center">
        {loadingImport && (
          <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
            <div className="w-2/5 h-auto mx-auto  ">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: Loading,
                  isStopped: false,
                  isPaused: false,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
              />
              <div className="text-center text-white text-xl">
                กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
              </div>
            </div>
          </div>
        )}
        <div className="ml-4">
          ค้นหาโดยใช้&nbsp;
          <label class="inline-flex items-center lg:ml-2">
            <input
              onChange={() => onSearchBy("request_id")}
              type="radio"
              class="form-radio"
              name="search"
              defaultChecked={true}
              checked={searchBy === "request_id"}
            />
            <span class="ml-2">Job. No.</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("name")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "name"}
            />
            <span class="ml-2">ชื่อ - นามสกุล</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("requestamount")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "requestamount"}
            />
            <span class="ml-2">วงเงินที่ได้</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("adminName")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "adminName"}
            />
            <span class="ml-2">ชื่อแอดมิน</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("phone_number")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "phone_number"}
            />
            <span class="ml-2">เบอร์โทร</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => onSearchBy("citizenid")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "citizenid"}
            />
            <span class="ml-2">บัตรประชาชน</span>
          </label>
          <div className="flex items-center mt-4">
            {/* {user?.groups?.some((group) => ["SuperAdmin"].includes(group)) && (
              <button
                disabled={!selectedRows.length}
                className={classNames(
                  " border p-1 px-2 rounded  duration-300 hover:text-white",
                  {
                    "bg-gray-300 cursor-not-allowed text-white":
                      !selectedRows.length,
                    "border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white":
                      selectedRows.length,
                  }
                )}
                onClick={onComplete}
              >
                Complete All
              </button>
            )} */}
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <ExcelFile
              filename={`TRANSFER_LOAN${format(new Date(), "yyyy-MM-dd")}`}
              element={<button id="transferLoan" hidden></button>}
            >
              <ExcelSheet
                dataSet={multiDataSet}
                name="TRANSFER LOAN"
              ></ExcelSheet>
            </ExcelFile>
            <ExcelFile
              filename={`INTERFACE_CREATE${format(new Date(), "yyyy-MM-dd")}`}
              element={<button id="interfaceCreate" hidden></button>}
            >
              <ExcelSheet
                dataSet={multiDataSetInterface}
                name="INTERFACE CREATE"
              ></ExcelSheet>
            </ExcelFile>
            <button
              disabled={!selectedRows}
              className={classNames(
                "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                    selectedRows.length,
                }
              )}
              onClick={onClickExport}
            >
              Export Excel
            </button>
            {/* <button
              disabled={loadingExportInterface}
              className={classNames(
                "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white flex items-center",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    loadingExportInterface,
                  "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                    !loadingExportInterface,
                }
              )}
              onClick={onClickExportExcelInterface}
            >
              {loadingExportInterface && <LoadingButton />} Export Excel
              InterfaceCreate
            </button> */}
            <div className="ml-2">
              <CSVReader
                parserOptions={importOptions}
                onFileLoaded={onImportExcel}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mx-4 w-full mb-6 mt-4 lg:flex items-center">
        <div className="lg:flex items-center ml-4 ">
          {/* <div className="lg:mr-2">Request Period</div> */}
          <input
            name="min"
            value={query.min}
            onChange={onField}
            type="date"
            className="p-2 py-1 border rounded shadow-sm"
          />
        </div>
        <div className="lg:flex items-center lg:ml-0">
          <div className="lg:ml-2 mr-2">To</div>
          <input
            name="max"
            value={query.max}
            onChange={onField}
            type="date"
            className="p-2 py-1 border rounded shadow-sm"
          />
        </div>
        <div className="my-1 lg:my-0 lg:ml-2 w-52">
          <Select
            defaultValue={optionsPackage[0]}
            value={getOption(optionsPackage, query.package)}
            options={optionsPackage}
            onChange={onSelect("package")}
          />
        </div>
        <div className="my-1 lg:my-0 lg:ml-2 w-52">
          <Select
            defaultValue={optionsStatus[0]}
            value={getOption(optionsStatus, query.status)}
            options={optionsStatus}
            onChange={onSelect("status")}
          />
        </div>
        <button
          className="ml-2 border border-blue-500 p-1 px-2 rounded text-blue-500 hover:bg-blue-600 duration-300 hover:text-white"
          onClick={onSubmitFilter}
        >
          Submit
        </button>
        <button
          className="ml-2 p-1 px-2 border border-red-500  rounded text-red-500 hover:bg-red-200 duration-300 hover:text-white"
          onClick={onClickResetFilter}
        >
          Clear
        </button>
        <svg
          onClick={() => getData(query)}
          xmlns="http://www.w3.org/2000/svg"
          className="h-9 w-9 rounded border border-gray-500 hover:bg-gray-200 text-gray-700 ml-2 p-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
      {!datas.length ? (
        pageType === "NEXT" ? (
          <ContainerContent>
            <div className="text-gray-700 font-bold text-xl w-full text-center mt-20">
              สิ้นสุดรายการ
            </div>
            <div className="w-full mt-2 flex items-center">
              {" "}
              <button
                className="bg-blue-500 text-xl p-4  mx-auto text-white mt-2 "
                onClick={onClickPrevPage}
              >
                ย้อนกลับ
              </button>
            </div>
          </ContainerContent>
        ) : (
          <ContainerContent>
            <DataEmpty />
          </ContainerContent>
        )
      ) : (
        <React.Fragment>
          <div className="flex w-full p-4 pt-0">
            <div className="my-auto w-full flex">
              {loadingCount ? (
                <div className="w-12 mr-2">
                  <Skeleton />
                </div>
              ) : (
                datasCount.length
              )}{" "}
              Records
            </div>
            <div className=" flex justify-between gap-4 ">
              <nav
                className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                aria-label="Pagination"
              >
                <PrevPage
                  canPreviousPage={pageIndex !== 0}
                  onClick={onClickPrevPage}
                />
                {paginationPages.map((_, i) => {
                  return (
                    <NumberPage number={pageIndex} pageIndex={pageIndex} />
                  );
                })}
                <NextPage onClick={onClickNextPage} canNextPage={true} />
              </nav>
              <div className="w-24 flex">
                <SelectRows
                  pageSize={pageSize}
                  onChange={onChangeLimit}
                  options={optionsLimit}
                />
              </div>
            </div>
          </div>
          <TransferLoanTable
            type={type}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            data={datas}
            getData={getData}
            query={query}
          />
        </React.Fragment>
      )}
    </ContainerContent>
  );
}

export default TransferLoanMain;
